import React, { useRef, useState, useEffect } from 'react';
import { View, StyleSheet, Animated } from 'react-native';
function useInterval(callback, delay) {
    const savedCallback = useRef();
    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current?.();
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
        else {
            return () => { };
        }
    }, [delay]);
}
const typeColors = {
    'primary': '#0095FF',
    'success': '#35C895',
    'error': '#CB3831',
};
const Progress = (props) => {
    const { initProgress, type } = props;
    const animation = useRef(new Animated.Value(0));
    const [progress, setProgress] = useState(initProgress || 0);
    useInterval(() => {
        if (progress < 100) {
            setProgress(progress + Math.random() * (0 + 10));
        }
    }, 1000);
    useEffect(() => {
        Animated.timing(animation.current, {
            toValue: progress,
            duration: 100,
            useNativeDriver: false,
        }).start();
    }, [progress]);
    const width = animation.current.interpolate({
        inputRange: [0, 100],
        outputRange: ['0%', '100%'],
        extrapolate: 'clamp',
    });
    return (<View style={styles.container}>
      <View style={styles.progressBar}>
        <Animated.View style={[
        StyleSheet.absoluteFill,
        {
            backgroundColor: typeColors[type],
            width,
        },
    ]}/>
      </View>
    </View>);
};
export default Progress;
const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F2F8FF',
        width: '100%',
    },
    progressBar: {
        flexDirection: 'row',
        height: 2,
        width: '100%',
    },
});
//# sourceMappingURL=Progress.js.map